/**
 * Full-screen textured quad shader
 */

const GlowShader = {

	name: 'GlowShader',

	uniforms: {

		'tDiffuse': { value: null },
		'opacity': { value: 1.0 },
        'size': { type: 'v2', value: null},
        'color': { type: 'v3', value: null},
        'intensity': { type: 'v3', value: null},
        'threshold': {type: 'b', value: null}

	},

	vertexShader: /* glsl */`

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,

	fragmentShader: /* glsl */`

		uniform float opacity;

		uniform sampler2D tDiffuse;

        uniform bool modeloverride;

		varying vec2 vUv;

        float glow_size = .5;
        vec3 glow_colour = vec3(0, 0, 0);
        float glow_intensity = 1.0;
        float glow_threshold = .5;
        
        void main() {
            vec4 pixel = texture2D( tDiffuse, vUv );
            if (pixel.a <= glow_threshold) {
                vec2 size = textureSize(tDiffuse, 0);
        	
                float uv_x = vUv.x * size.x;
                float uv_y = vUv.y * size.y;
        
                float sum = 0.0;
                for (int n = 0; n < 9; ++n) {
                    uv_y = (vUv.y * size.y) + (glow_size * float(n - 4.5));
                    float h_sum = 0.0;
                    h_sum += texelFetch(t0, ivec2(uv_x - (4.0 * glow_size), uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x - (3.0 * glow_size), uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x - (2.0 * glow_size), uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x - glow_size, uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x, uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x + glow_size, uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x + (2.0 * glow_size), uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x + (3.0 * glow_size), uv_y), 0).a;
                    h_sum += texelFetch(t0, ivec2(uv_x + (4.0 * glow_size), uv_y), 0).a;
                    sum += h_sum / 9.0;
                }
        
                gl_FragColor = vec4(glow_colour, (sum / 9.0) * glow_intensity);
            }`

};
